// import React, { useEffect, useState } from "react";
// import { Button, Card, CardBody, CardHeader, Table } from "reactstrap";
// import AxiosInstance from "../../AxiosInstance";
// import moment from "moment";
// import { useLocation, useNavigate } from "react-router-dom";
// import { handleAuth } from "../../../components/Login/Auth";
// import "../style.css";
// import Swal from "sweetalert2";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import CallIcon from "@mui/icons-material/Call";
// import { LoaderComponent } from "../../../components/Icon/Index";
// import { Grid, Typography } from "@mui/material";
// import { Row, Col } from "react-bootstrap";
// import TableCell from "@mui/material/TableCell";
// import TableRow from "@mui/material/TableRow";
// import BlueButton from "../../../components/Button/BlueButton";
// import WhiteButton from "../../../components/Button/WhiteButton";

// function ConfirmAppointment() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [loader, setLoader] = useState(true);
//   const [quotesData, setQuotesData] = useState(null);
//   const [tokenDecode, setTokenDecode] = useState({});
//   const [isConfirmed, setIsConfirmed] = useState(false);

//   const fetchData = async () => {
//     try {
//       const res = await handleAuth(navigate, location);
//       setTokenDecode(res?.data);
//     } catch (error) {
//       console.error("Error fetching token data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const companyId = tokenDecode.CompanyId;
//   const WorkerId = localStorage.getItem("worker_id");
//   const [isComplete, setIsComplete] = useState(false);

//   const fetchVisitData = async () => {
//     if (companyId && location?.state?.id && WorkerId) {
//       setLoader(true);
//       try {
//         const response = await AxiosInstance.get(
//           `/v1/worker/get-worker-visits-details/${location?.state?.id}/${WorkerId}`
//         );
//         if (response?.data.statusCode === 200 && response?.data?.data) {
//           const visitData = response?.data?.data;
//           setQuotesData(visitData);

//           const isWorkerConfirmed = visitData.ConfirmWorker?.includes(WorkerId);
//           setIsConfirmed(isWorkerConfirmed);

//           const isWOrkerCompleted = visitData.ConfirmWorker?.includes(WorkerId);
//           setIsComplete(isWOrkerCompleted);
//         } else {
//           console.error("Unexpected data structure or status code from API.");
//         }
//       } catch (error) {
//         console.error("API error:", error);
//       } finally {
//         setLoader(false);
//       }
//     } else {
//       console.error("Company ID, Visit ID, or Worker ID is not valid.");
//       setLoader(false);
//     }
//   };

//   useEffect(() => {
//     if (tokenDecode.CompanyId && location?.state?.id) {
//       const workerId = localStorage.getItem("worker_id");
//       fetchVisitData(tokenDecode.CompanyId, location?.state?.id, workerId);
//     }
//   }, [tokenDecode.CompanyId, location?.state?.id, isComplete]);

//   const handleConfirmAppointment = async () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Do you want to confirm this appointment?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, confirm it!",
//       cancelButtonText: "No, cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         setIsConfirmed(true);
//         try {
//           const objact = {
//             WorkerId,
//             CompanyId: companyId,
//             AddedAt: new Date(),
//           };
//           const response = await AxiosInstance.put(
//             `/v1/worker/confirm-visit-by-worker/${location?.state?.id}/${quotesData.ContractId}`,
//             objact
//           );
//           if (response?.data && response?.data.statusCode === 200) {
//             Swal.fire(
//               "Confirmed!",
//               "The appointment has been confirmed .",
//               "success"
//             );
//           } else {
//             setIsConfirmed(true);
//             Swal.fire(
//               "Error!",
//               "Unable to confirm the appointment  . Please try again.",
//               "error"
//             );
//           }
//         } catch (error) {
//           setIsConfirmed(false);
//           console.error("Error confirming appointment:", error);
//           Swal.fire(
//             "Error!",
//             "Something went wrong. Please try again.",
//             "error"
//           );
//         }
//       }
//     });
//   };

//   const Completepopup = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Do you want to complete this appointment?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, complete it!",
//       cancelButtonText: "No, cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         setIsComplete(true);
//         try {
//           const objact = {
//             WorkerId,
//             CompanyId: companyId,
//             AddedAt: new Date(),
//           };
//           const response = await AxiosInstance.put(
//             `/v1/visit/confirm-complete/${location?.state?.id}/${quotesData.ContractId}`,
//             objact
//           );
//           if (setIsComplete == true) {
//             Completepopup(false);
//           }
//           if (response?.data && response?.data.statusCode === 200) {
//             Swal.fire(
//               "Completed!",
//               "The appointment has been completed in the database.",
//               "success"
//             );
//           } else {
//             setIsComplete(false);
//             Swal.fire(
//               "Error!",
//               "Unable to complete the appointment in the database. Please try again.",
//               "error"
//             );
//           }
//         } catch (error) {
//           setIsComplete(false);
//           console.error("Error completing appointment in database:", error);
//           Swal.fire(
//             "Error!",
//             "Something went wrong. Please try again.",
//             "error"
//           );
//         }
//       }
//     });
//   };

//   return (
//     <>
//       {loader ? (
//         <Grid
//           className="d-flex flex-direction-row justify-content-center align-items-center p-5 m-5"
//           style={{ height: "80vh", marginTop: "25%" }}
//         >
//           <LoaderComponent loader={loader} height="50" width="50" />
//         </Grid>
//       ) : (
//         <Grid
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             width: "100%",
//             alignItems: "center",
//           }}
//         >
//           <Grid style={{ width: "67%" }} className="AppointmentNavigateBefore">
//             <BlueButton
//               className="bg-blue-color"
//               onClick={() => navigate(-1)}
//               label={<ArrowBackIcon />}
//             />
//           </Grid>
//           <Col
//             className="invoice-card col-8 appointmentConfirmedBoxs"
//             style={{ marginTop: "10px", padding: "20px", borderRadius: "12px" }}
//             xl={8}
//           >
//             <CardHeader>
//               <Grid className="text-end">
//                 {isConfirmed ? (
//                     <WhiteButton
//                       onClick={Completepopup}
//                       className="Appointment text-blue-color"
//                       style={{
//                         border: "2px solid #0f2b46",
//                         background: "#DBECFF",
//                         borderRadius: "20px",
//                         fontWeight: 600,
//                       }}
//                       disabled={isComplete}
//                       label={isComplete ? "Complete" : "Confirmed"}
//                     />
//                 ) : (
//                   <WhiteButton
//                     size="sm"
//                     className="bg-blue-color text-white-color"
//                     onClick={handleConfirmAppointment}
//                     label="Confirm Appointment"
//                   />
//                 )}
//               </Grid>
//             </CardHeader>
//             <CardBody>
//               <Grid
//                 className="d-flex appointmentWIdthFlex"
//                 style={{
//                   overflowX: "auto",
//                   width: "100%",
//                 }}
//               >
//                 <Col
//                   className="col-6 appointmnetWorkerDetail"
//                   style={{
//                     display: "inline-block",
//                     width: "50%",
//                     minWidth: "200px",
//                   }}
//                   xl={6}
//                 >
//                   <Typography
//                     style={{
//                       fontWeight: "700",
//                       fontSize: "18px",
//                       color: headingInk,
//                     }}
//                   >
//                     Contract #
//                     {quotesData?.ContractData[0]?.ContractNumber || ""}
//                   </Typography>
//                   <Typography
//                     style={{ fontWeight: 700 }}
//                     className="text-blue-color heading-five"
//                   >
//                     {quotesData?.CustomerData[0]?.FirstName ||
//                       "FirstName not available"}{" "}
//                     {quotesData?.CustomerData[0]?.LastName ||
//                       "LastName not available"}{" "}
//                     - {quotesData?.ItemName || "ItemName not available"}
//                   </Typography>
//                   <Typography
//                     style={{
//                       fontSize: "17px",
//                       color: headingInk,
//                       fontWeight: 500,
//                     }}
//                   >
//                     {quotesData?.Note || "Note not available"}
//                   </Typography>
//                   <Typography className="text-blue-color">
//                     {quotesData?.LocationData?.Address ||
//                       "Address not available"}{" "}
//                     {quotesData?.LocationData?.City || "City not available"},{" "}
//                     {quotesData?.LocationData?.State || "State not available"},{" "}
//                     <br />{" "}
//                     {quotesData?.LocationData?.Zip || "Zip not available"}-{" "}
//                     {quotesData?.LocationData?.Country ||
//                       "Country not available"}
//                   </Typography>
//                 </Col>

//                 <Col
//                   className="col-6 phoneNumberDetailAnddateAppoin"
//                   style={{
//                     display: "inline-block",
//                     width: "50%",
//                     minWidth: "200px",
//                   }}
//                   xl={6}
//                 >
//                   <Typography
//                     className="d-flex align-items-center gap-2 text-blue-color mb-3"
//                     style={{ fontWeight: 600 }}
//                   >
//                     <CalendarMonthIcon className="text-blue-color" />{" "}
//                     {moment(quotesData?.StartDate).format("YYYY-MM-DD")}
//                   </Typography>
//                   <Typography className="d-flex align-items-center gap-2 text-blue-color appointmentPhoneNUmber">
//                     <CallIcon style={{ fontSize: "20px" }} />{" "}
//                     {quotesData?.CustomerData[0]?.PhoneNumber ||
//                       "Phone Number not available"}
//                   </Typography>
//                 </Col>
//               </Grid>
//               <Typography></Typography>
//               <hr />
//               <Grid>
//                 <Typography
//                   style={{ fontWeight: 700 }}
//                   className="text-blue-color mb-0"
//                 >
//                   Line Items
//                 </Typography>
//                 <Table className="p-0">
//                   <thead>
//                     <TableRow>
//                       <TableCell style={{ paddingLeft: 0 }}>
//                         Product/Service
//                       </TableCell>
//                       <TableCell className="text-end">Qty</TableCell>
//                     </TableRow>
//                   </thead>
//                   <tbody>
//                     {quotesData?.ContractItemData?.length > 0 ? (
//                       quotesData?.ContractItemData.map((item) => (
//                         <TableRow key={item._id}>
//                           <td style={{ paddingLeft: 0 }}>
//                             {item?.Name || "Materials & Labor not Available"}
//                           </td>
//                           <td className="text-end">
//                             {item.Unit
//                               ? `${item?.Unit} Units`
//                               : item.Hourly
//                               ? `${item?.Hourly} Hours`
//                               : item.Square
//                               ? `${item?.Square} SqFeet`
//                                : item.Fixed
//                               ? `${item?.Fixed} Fixed`
//                               : "Unit not available"}
//                           </td>
//                         </TableRow>
//                       ))
//                     ) : (
//                       <TableRow>
//                         <td colSpan="2" className="text-center">
//                           No items available
//                         </td>
//                       </TableRow>
//                     )}
//                   </tbody>
//                 </Table>
//               </Grid>
//             </CardBody>
//           </Col>
//         </Grid>
//       )}
//     </>
//   );
// }

// export default ConfirmAppointment;

import React, { useEffect, useMemo, useState } from "react";
import { Table } from "reactstrap";
import AxiosInstance from "../../AxiosInstance";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { handleAuth } from "../../../components/Login/Auth";
import { useUserTimezoneFormatter } from "../../../components/UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import "../style.css";
import Swal from "sweetalert2";
import CustomSwal from "../../../components/Swal/CustomSwal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CallIcon from "@mui/icons-material/Call";
import BlueButton from "../../../components/Button/BlueButton";
import WhiteButton from "../../../components/Button/WhiteButton";
import {
  Grid,
  Typography,
  Box,
  Paper,
  Chip,
  Avatar,
  Card as MuiCard,
  CardContent,
  IconButton,
  Fade,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DoneIcon from "@mui/icons-material/Done";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { EditIcon, LoaderComponent } from "../../../components/Icon/Index";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { getItem } from "../../../utils/storage";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import InputText from "../../../components/InputFields/InputText";
import showToast from "../../../components/Toast/Toster";
import {
  JobberStatusBadge,
  getVisitAppointmentStatusTone,
} from "../../../components/MuiTable/index.jsx";

/** Align with project tokens: Navy Deep + Amber (see :root in index.css) */
const themeColors = {
  orange: "#D97706",
  blue: "#0F2B46",
  lightOrange: "rgba(212, 148, 58, 0.12)",
  lightBlue: "rgba(15, 43, 70, 0.06)",
};

/** Edit tile — same as staff Worker Time Entry (`TimeTracking/index.jsx`) / Materials & Labor */
const ML_EDIT_TILE_BG = "#DCFCE7";
const ML_EDIT_TILE_BORDER = "rgba(4, 120, 87, 0.18)";
const ML_EDIT_ICON = "#047857";

/** Confirm appointment — surfaces follow MUI theme (worker dark mode) */
function buildConfirmLayout(theme) {
  const p = theme.palette;
  const isDark = p.mode === "dark";
  return {
    page: { pb: { xs: 2, md: 3 } },
    contentWrap: {
      width: "100%",
      maxWidth: "100%",
      margin: 0,
      padding: { xs: "0.75rem", sm: "1rem", md: "1.25rem" },
      boxSizing: "border-box",
    },
    mainCard: {
      border: `1px solid ${p.divider}`,
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: p.background.paper,
      boxShadow: "var(--shadow-sm)",
    },
    headerBar: {
      backgroundColor: "transparent",
      color: isDark ? p.text.primary : themeColors.blue,
      px: { xs: 2, sm: 2.5 },
      py: { xs: 1.5, sm: 1.75 },
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 2,
      flexWrap: "wrap",
    },
    contentBody: {
      padding: { xs: "20px", sm: "28px" },
    },
    infoCard: {
      background: isDark ? p.action.hover : "#F9FAFB",
      border: `1px solid ${p.divider}`,
      borderRadius: "12px",
      padding: { xs: "14px", sm: "18px" },
      height: "100%",
    },
    infoLabel: {
      color: p.text.secondary,
      fontWeight: 500,
      fontSize: { xs: "11px", sm: "12px" },
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: { xs: "8px", sm: "10px" },
    },
    materialsPanel: {
      border: `1px solid ${p.divider}`,
      borderRadius: "12px",
      backgroundColor: p.background.paper,
      p: { xs: 2, sm: 2.5 },
    },
    dateChangeWrap: {
      border: `1px solid ${p.divider}`,
      borderRadius: "12px",
      backgroundColor: p.background.paper,
      overflow: "hidden",
    },
    dateChangeHeader: {
      color: isDark ? p.text.primary : "#0F2B46",
      px: { xs: 2, sm: 2.5 },
      py: { xs: 1.25, sm: 1.5 },
    },
  };
}

// Helper function to format time from ISO string or various formats
const formatTimeFromString = (timeString) => {
  if (!timeString) return null;
  
  const timeStr = String(timeString).trim();
  if (!timeStr) return null;
  
  // Try parsing as ISO string first (from TimePicker's toISOString())
  // ISO strings look like "2024-01-01T14:30:00.000Z" or "2024-01-01T14:30:00Z"
  let timeMoment = moment(timeStr);
  
  // If ISO parsing succeeds, extract just the time
  if (timeMoment.isValid()) {
    // Check if it's an ISO string (contains 'T' and possibly 'Z')
    if (timeStr.includes('T') || timeStr.includes('Z')) {
      // Extract time portion and format it
      return timeMoment.format("hh:mm A");
    }
    // If it's already a valid moment, format it
    return timeMoment.format("hh:mm A");
  }
  
  // If ISO parsing fails, try common time formats
  // Try HH:mm format
  timeMoment = moment(timeStr, "HH:mm", true);
  if (timeMoment.isValid()) {
    return timeMoment.format("hh:mm A");
  }
  
  // Try hh:mm A format (already in 12-hour format)
  timeMoment = moment(timeStr, ["hh:mm A", "h:mm A", "HH:mm:ss", "HH:mm"], true);
  if (timeMoment.isValid()) {
    return timeMoment.format("hh:mm A");
  }
  
  return null;
};

function ConfirmAppointment() {
  const theme = useTheme();
  const confirmLayout = useMemo(() => buildConfirmLayout(theme), [theme]);
  const headingInk =
    theme.palette.mode === "dark" ? theme.palette.primary.light : themeColors.blue;
  const muted = theme.palette.text.secondary;
  const paperBg = theme.palette.background.paper;

  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  const [quotesData, setQuotesData] = useState(null);
  const [tokenDecode, setTokenDecode] = useState({});
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [showConfirmSwal, setShowConfirmSwal] = useState(false);
  const [showCompleteSwal, setShowCompleteSwal] = useState(false);
  const [DateDecode, setDateDecode] = useState({});
  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY");
  const [showChangeDateDialog, setShowChangeDateDialog] = useState(false);
  
  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();
  
  const [newDate, setNewDate] = useState(null);
  const [originalDate, setOriginalDate] = useState(null);
  const [dateChangeReason, setDateChangeReason] = useState("");
  const [dateChangeLoading, setDateChangeLoading] = useState(false);
  const [showDateChangeErrorSwal, setShowDateChangeErrorSwal] = useState(false);
  const [pendingRequest, setPendingRequest] = useState(null); // State for tracking pending date change requests
  const [dateChangeRequests, setDateChangeRequests] = useState([]);
  const [contractVisits, setContractVisits] = useState([]);
  const [dateError, setDateError] = useState(false);
  const [reasonError, setReasonError] = useState(false);

  const fetchData = async () => {
    try {
      const res = await handleAuth(navigate, location);
      setTokenDecode(res?.data);
      if (res?.themes?.Format) {
        setDateDecode(res.themes);
      } else {
        setDateDecode({ Format: "MM/DD/YYYY" });
      }
    } catch (error) {
      console.error("Error fetching token data:", error);
      setDateDecode({ Format: "MM/DD/YYYY" });
    }
  };

  useEffect(() => {
    const handleDateFormat = () => {
      if (DateDecode?.Format) {
        try {
          const testDate = moment().format(DateDecode.Format);
          if (testDate && testDate !== "Invalid date") {
            setDateFormat(DateDecode.Format);
          } else {
            console.warn(
              "Invalid date format from backend, using default:",
              DateDecode.Format
            );
            setDateFormat("MM/DD/YYYY");
          }
        } catch (error) {
          console.warn("Error validating date format, using default:", error);
          setDateFormat("MM/DD/YYYY");
        }
      } else {
        setDateFormat("MM/DD/YYYY");
      }
    };
    handleDateFormat();
  }, [DateDecode]);

  useEffect(() => {
    fetchData();
  }, []);

  const companyId = tokenDecode?.CompanyId;
  const WorkerId = getItem("worker_id");
  const [isComplete, setIsComplete] = useState(false);

  // Get visitId from location state (no URL parameters)
  const getVisitId = () => {
    return location?.state?.id;
  };

  const fetchVisitData = async () => {
    const visitId = getVisitId();

    if (companyId && visitId && WorkerId) {
      setLoader(true);

      try {
        const response = await AxiosInstance.get(
          `/v1/worker/get-worker-visits-details/${visitId}/${WorkerId}`
        );

        if (response?.data.statusCode === 200 && response?.data?.data) {
          const visitData = response?.data?.data;

          if (!visitData) {
            showToast.error(
              "Visit information is missing. Please refresh the page."
            );
            setLoader(false);
            return;
          }

          setQuotesData(visitData);

          // Check if visit is confirmed by worker, customer, or company
          const isWorkerConfirmed = visitData.ConfirmWorker?.includes(WorkerId);
          const isCustomerConfirmed = visitData.IsConfirm === true;
          const isCompanyConfirmed = visitData.IsConfirmByWorker === true;
          const isStatusConfirmed = visitData.Status === "Confirmed";

          // Visit is confirmed if any party confirmed it
          const visitIsConfirmed =
            isWorkerConfirmed ||
            isCustomerConfirmed ||
            isCompanyConfirmed ||
            isStatusConfirmed;
          setIsConfirmed(visitIsConfirmed);

          // Check if visit is completed
          const isWorkerCompleted =
            visitData.CompleteWorker?.includes(WorkerId) ||
            visitData.CompletedWorker?.includes(WorkerId) ||
            visitData.CompleteVisits?.includes(WorkerId) ||
            visitData.CompletedVisits?.includes(WorkerId) ||
            visitData.Status === "completed" ||
            visitData.Status === "Completed";
          const isVisitCompleted =
            visitData.IsComplete === true || isWorkerCompleted;
          setIsComplete(isVisitCompleted);

          // Fetch date change requests
          if (visitData?.ContractId) {
            try {
              const requestsResponse = await AxiosInstance.get(
                `/v1/visit/date-change-requests/${visitId}/${visitData.ContractId}`
              );

              if (requestsResponse?.data?.statusCode === 200) {
                setDateChangeRequests(requestsResponse?.data?.data || []);
                const pendingRequests = (
                  requestsResponse?.data?.data || []
                ).filter((req) => req.Status === "Pending");
                if (pendingRequests.length > 0) {
                  setPendingRequest(pendingRequests[0]);
                } else {
                  setPendingRequest(null);
                }
              }
            } catch (error) {
              console.error("Error fetching date change requests:", error);
            }

            // Fetch contract visits to check for booked dates
            try {
              const contractResponse = await AxiosInstance.get(
                `/v1/contract/${visitData.ContractId}`
              );
              if (
                contractResponse?.data?.statusCode === 200 &&
                contractResponse?.data?.data?.visitsData
              ) {
                setContractVisits(contractResponse.data.data.visitsData || []);
              }
            } catch (error) {
              console.error("Error fetching contract visits:", error);
            }
          }
        } else {
          showToast.error(
            "Failed to load visit data. Please refresh the page."
          );
        }
      } catch (error) {
        console.error("Error fetching visit data:", error);
        showToast.error(
          error?.response?.data?.message ||
            "Failed to load visit data. Please refresh the page."
        );
      } finally {
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    const visitId = getVisitId();
    if (tokenDecode?.CompanyId && visitId) {
      fetchVisitData();
    }
  }, [tokenDecode?.CompanyId, location?.state?.id]);

  const handleConfirmAppointment = async () => {
    setShowConfirmSwal(true);
  };

  const handleConfirmAppointmentConfirm = async (reason) => {
    setShowConfirmSwal(false);
    setIsConfirmed(true);
    try {
      const visitId = getVisitId();
      const objact = {
        WorkerId,
        CompanyId: companyId,
        AddedAt: new Date(),
      };
      const response = await AxiosInstance.put(
        `/v1/worker/confirm-visit-by-worker/${visitId}/${quotesData?.ContractId}`,
        objact
      );
      if (response?.data && response?.data.statusCode === 200) {
        await fetchVisitData();
        Swal.fire(
          "Confirmed!",
          "The appointment has been confirmed .",
          "success"
        );
      } else {
        setIsConfirmed(false);
        Swal.fire(
          "Error!",
          "Unable to confirm the appointment  . Please try again.",
          "error"
        );
      }
    } catch (error) {
      setIsConfirmed(false);
      console.error("Error confirming appointment:", error);
      Swal.fire(
        "Unable to confirm appointment",
        "We couldn't confirm this appointment. Please try again in a moment.",
        "error"
      );
    }
  };

  // Function to check if a date already has a visit booked
  const shouldDisableDate = (date) => {
    if (!contractVisits || contractVisits.length === 0) {
      return false;
    }

    // Don't disable the current visit's date
    const currentVisitDate = quotesData?.StartDate
      ? dayjs(quotesData.StartDate).format("YYYY-MM-DD")
      : null;
    const checkDate = dayjs(date).format("YYYY-MM-DD");

    if (currentVisitDate === checkDate) {
      return false; // Allow selecting the current visit's date
    }

    // Check if any visit exists on this date
    return contractVisits.some((visit) => {
      if (!visit.StartDate) return false;
      const visitDateStr = dayjs(visit.StartDate).format("YYYY-MM-DD");
      return visitDateStr === checkDate;
    });
  };

  const handleOpenChangeDateDialog = async () => {
    // Check for pending request first
    const visitId = getVisitId();

    // Validate that we have the required data
    if (!visitId) {
      showToast.error("Visit ID is missing. Please refresh the page.");
      return;
    }

    // Check if quotesData is loaded
    if (!quotesData) {
      showToast.error(
        "Visit data is still loading. Please wait a moment and try again."
      );
      return;
    }

    // Check if visit is confirmed or completed - prevent date changes
    if (isConfirmed || isComplete) {
      showToast.warning(
        "Cannot change visit date. The visit has been confirmed or completed. Date changes are not allowed after confirmation or completion."
      );
      return;
    }

    // Get ContractId from quotesData - check multiple possible locations
    // Also check location state as fallback (similar to customer file)
    const contractId =
      quotesData?.ContractId ||
      quotesData?.ContractData?.[0]?.ContractId ||
      location?.state?.contractId;

    if (!contractId) {
      console.error("ContractId not found. quotesData:", quotesData);
      showToast.error(
        "Contract information is missing. Please refresh the page."
      );
      return;
    }

    try {
      const response = await AxiosInstance.get(
        `/v1/visit/date-change-requests/${visitId}/${contractId}`
      );

      if (response?.data?.statusCode === 200 && response?.data?.data) {
        const pendingRequests = response.data.data.filter(
          (req) => req.Status === "Pending"
        );
        if (pendingRequests.length > 0) {
          showToast.warning(
            "A visit date change request is already pending for this visit."
          );
          setPendingRequest(pendingRequests[0]);
          return;
        }
      }
    } catch (error) {
      console.error("Error checking pending requests:", error);
      // Don't block the dialog if this check fails, just log the error
    }

    if (quotesData?.StartDate) {
      const currentDate = dayjs(quotesData.StartDate);
      setNewDate(currentDate);
      setOriginalDate(currentDate);
    } else {
      // If no StartDate, set to today
      setNewDate(dayjs());
      setOriginalDate(dayjs());
    }
    setDateChangeReason("");
    setDateError(false);
    setReasonError(false);
    setPendingRequest(null);
    setShowChangeDateDialog(true);
  };

  const handleCloseChangeDateDialog = () => {
    setShowChangeDateDialog(false);
    setNewDate(null);
    setOriginalDate(null);
    setDateChangeReason("");
    setDateError(false);
    setReasonError(false);
  };

  const Completepopup = () => {
    setShowCompleteSwal(true);
  };

  const handleCompleteAppointmentConfirm = async (reason) => {
    setShowCompleteSwal(false);
    setIsComplete(true);
    try {
      const visitId = getVisitId();
      const objact = {
        WorkerId,
        CompanyId: companyId,
        AddedAt: new Date(),
      };
      const response = await AxiosInstance.put(
        `/v1/visit/confirm-complete/${visitId}/${quotesData?.ContractId}`,
        objact
      );

      if (response?.data && response?.data.statusCode === 200) {
        await fetchVisitData();
        Swal.fire(
          "Completed!",
          "The appointment has been completed in the database.",
          "success"
        );
      } else {
        setIsComplete(false);
        Swal.fire(
          "Error!",
          "Unable to complete the appointment in the database. Please try again.",
          "error"
        );
      }
    } catch (error) {
      setIsComplete(false);
      console.error("Error completing appointment in database:", error);
      Swal.fire(
        "Unable to complete appointment",
        "We couldn't mark this appointment complete. Please try again in a moment.",
        "error"
      );
    }
  };

  return (
    <Box sx={confirmLayout.page}>
      {loader ? (
        <Grid
          className="d-flex flex-direction-row justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <LoaderComponent loader={loader} height="50" width="50" />
        </Grid>
      ) : (
        <Fade in={!loader} timeout={800}>
          <Box sx={confirmLayout.contentWrap}>
            <Box mb={2}>
              <BlueButton
                className="back-button"
                sx={{
                  borderRadius: "8px",
                  minWidth: "unset",
                  width: "40px",
                  height: "40px",
                  background: themeColors?.blue,
                }}
                onClick={() => navigate(-1)}
                label={<ArrowBackIcon sx={{ fontSize: "1.2rem" }} />}
              />
            </Box>

            <Box sx={confirmLayout.mainCard}>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
              <Box sx={confirmLayout.headerBar}>
                <Box sx={{ flex: 1, minWidth: 0, pr: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      margin: 0,
                      lineHeight: 1.35,
                      color: headingInk,
                    }}
                  >
                    {quotesData?.VisitTitle ||
                      quotesData?.ItemName ||
                      "Appointment Details"}
                  </Typography>
                  {quotesData?.VisitTitle && (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "11px",
                        mt: "2px",
                        fontWeight: 400,
                        color: "#6B7280",
                      }}
                    >
                      Visit Title
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                  }}
                >
                  {pendingRequest && (
                    <Box
                      sx={{
                        backgroundColor: themeColors?.orange,
                        color: "white",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: 600,
                        lineHeight: 1.2,
                      }}
                    >
                      Request Pending
                    </Box>
                  )}
                  {isConfirmed !== null && (
                    <>
                      {isConfirmed ? (
                        <Box
                          sx={{
                            background: themeColors?.orange,
                            color: "white",
                            padding: "4px 12px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            fontWeight: 600,
                            lineHeight: 1.2,
                            cursor: !isComplete ? "pointer" : "default",
                          }}
                          onClick={!isComplete ? Completepopup : undefined}
                        >
                          {isComplete ? "Completed" : "Confirmed"}
                        </Box>
                      ) : (
                        moment(quotesData?.StartDate).isSameOrAfter(
                          moment(),
                          "day"
                        ) && (
                          <Button
                            disableElevation
                            disableRipple
                            sx={{
                              background: themeColors?.orange,
                              backgroundColor: themeColors?.orange,
                              color: "white",
                              padding: "4px 14px",
                              fontSize: "12px",
                              fontWeight: 600,
                              textTransform: "none",
                              borderRadius: "4px",
                              minWidth: "auto",
                              lineHeight: 1.2,
                              boxShadow: "none",
                              "&:hover": {
                                background: themeColors?.orange,
                                backgroundColor: themeColors?.orange,
                                boxShadow: "none",
                              },
                              "&:active": {
                                background: themeColors?.orange,
                                backgroundColor: themeColors?.orange,
                              },
                              "&:focus": {
                                background: themeColors?.orange,
                                backgroundColor: themeColors?.orange,
                              },
                              "&.Mui-focusVisible": {
                                background: themeColors?.orange,
                                backgroundColor: themeColors?.orange,
                              },
                            }}
                            onClick={handleConfirmAppointment}
                          >
                            Confirm Appointment
                          </Button>
                        )
                      )}
                    </>
                  )}
                </Box>
              </Box>
              <Box
                className="bg-orange-color"
                sx={{ height: "2px", width: "100%", flexShrink: 0 }}
                aria-hidden
              />
              </Box>

              {/* Content - info cards same as Make Payment / invoice-payment */}
              <Box sx={confirmLayout.contentBody}>
                <Grid container spacing={{ xs: 2, sm: 2.5 }} sx={{ mb: 3.5 }}>
                  {/* Contract Reference */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Typography sx={confirmLayout.infoLabel}>
                        Contract Reference
                      </Typography>
                      <Typography
                        sx={{
                          color: headingInk,
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: "600",
                          wordBreak: "break-word",
                        }}
                      >
                        {quotesData?.ContractNumber ||
                          quotesData?.ContractData?.[0]?.ContractNumber ||
                          "Not Available"}
                        {(() => {
                          const contractTitle =
                            quotesData?.ContractTitle ||
                            quotesData?.ContractData?.[0]?.Title ||
                            quotesData?.ContractData?.Title;
                          return contractTitle ? ` | ${contractTitle}` : "";
                        })()}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Service Location */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Typography sx={confirmLayout.infoLabel}>
                        Service Location
                      </Typography>
                      <Typography
                        sx={{
                          color: headingInk,
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: "600",
                          wordBreak: "break-word",
                        }}
                      >
                        {quotesData?.Location?.Address ||
                          quotesData?.LocationData?.Address ||
                          "Address not available"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#6B7280",
                          fontSize: { xs: "12px", sm: "14px" },
                          mt: 0.5,
                          wordBreak: "break-word",
                        }}
                      >
                        {quotesData?.Location?.City ||
                          quotesData?.LocationData?.City ||
                          "City not available"}
                        , {quotesData?.Location?.State ||
                          quotesData?.LocationData?.State ||
                          "State not available"}{" "}
                        {quotesData?.Location?.Zip ||
                          quotesData?.LocationData?.Zip ||
                          "Zip not available"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Customer */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Typography sx={confirmLayout.infoLabel}>
                        Customer
                      </Typography>
                      <Typography
                        sx={{
                          color: headingInk,
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: "600",
                          wordBreak: "break-word",
                        }}
                      >
                        {(() => {
                          const customer =
                            quotesData?.CustomerData?.[0] || quotesData?.CustomerData;
                          if (customer) {
                            if (customer.FirstName && customer.LastName) {
                              return `${customer.FirstName} ${customer.LastName}`;
                            }
                            if (customer.OwnerName) return customer.OwnerName;
                            if (customer.FullName) return customer.FullName;
                          }
                          return "Customer name not available";
                        })()}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Status Details */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Typography sx={confirmLayout.infoLabel}>
                        Status Details
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        {quotesData?.Status &&
                          String(quotesData.Status).trim() !== "" && (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <JobberStatusBadge
                                tone={getVisitAppointmentStatusTone(
                                  quotesData.Status
                                )}
                              >
                                {quotesData.Status}
                              </JobberStatusBadge>
                            </Box>
                          )}
                        {Array.isArray(quotesData?.ConfirmWorkerDetails) &&
                          quotesData.ConfirmWorkerDetails.length > 0 &&
                          quotesData.ConfirmWorkerDetails.map((worker, index) => (
                            <Typography
                              key={index}
                              sx={{
                                color: headingInk,
                                fontWeight: 500,
                                fontSize: { xs: "13px", sm: "14px" },
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <DoneIcon sx={{ fontSize: "14px", color: "green" }} />
                              {worker?.OwnerName
                                ? `Confirmed By Account Owner - ${worker.OwnerName}`
                                : worker?.FirstName && worker?.LastName
                                ? `Confirmed By Worker - ${worker.FirstName} ${worker.LastName}`
                                : "Confirmed By Worker - Unknown Worker"}
                            </Typography>
                          ))}
                        {quotesData?.Status === "Completed" &&
                          Array.isArray(quotesData?.ConfirmWorkerDetails) &&
                          quotesData.ConfirmWorkerDetails.length > 0 &&
                          quotesData.ConfirmWorkerDetails.map((worker, index) => (
                            <Typography
                              key={`complete-${index}`}
                              sx={{
                                color: headingInk,
                                fontWeight: 500,
                                fontSize: { xs: "13px", sm: "14px" },
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <DoneIcon sx={{ fontSize: "14px", color: "green" }} />
                              {worker?.OwnerName
                                ? `Completed By Account Owner - ${worker.OwnerName}`
                                : worker?.FirstName && worker?.LastName
                                ? `Completed By Worker - ${worker.FirstName} ${worker.LastName}`
                                : "Completed By Worker - Unknown Worker"}
                            </Typography>
                          ))}
                        {quotesData?.IsConfirm && (
                          <Typography
                            sx={{
                              color: headingInk,
                              fontWeight: 500,
                              fontSize: { xs: "13px", sm: "14px" },
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <DoneIcon sx={{ fontSize: "14px", color: "green" }} />
                            Confirmed By Customer -{" "}
                            {(quotesData?.CustomerData?.[0] || quotesData?.CustomerData)
                              ? `${(quotesData.CustomerData[0] || quotesData.CustomerData).FirstName || ""} ${(quotesData.CustomerData[0] || quotesData.CustomerData).LastName || ""}`.trim()
                              : "Customer"}
                          </Typography>
                        )}
                        {!quotesData?.IsConfirmByWorker &&
                          !quotesData?.IsComplete &&
                          !quotesData?.IsConfirm &&
                          (!Array.isArray(quotesData?.ConfirmWorkerDetails) ||
                            quotesData.ConfirmWorkerDetails.length === 0) &&
                          (!quotesData?.Status ||
                            String(quotesData.Status).trim() === "") && (
                            <JobberStatusBadge tone="neutral">
                              No status updates available
                            </JobberStatusBadge>
                          )}
                      </Box>
                    </Box>
                  </Grid>

                  {/* Appointment Date & Time - single row to reduce height */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 1.5,
                          flexWrap: "wrap",
                        }}
                      >
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            sx={{
                              ...confirmLayout.infoLabel,
                              marginBottom: { xs: "4px", sm: "6px" },
                            }}
                          >
                            Appointment Date & Time
                          </Typography>
                          <Typography
                            sx={{
                              color: headingInk,
                              fontSize: { xs: "14px", sm: "16px" },
                              fontWeight: "600",
                              wordBreak: "break-word",
                              display: "block",
                              mb: 0.5,
                            }}
                          >
                            {formatDateWithUserTimezone(quotesData?.StartDate, {
                              dateFormat: dateFormat,
                              includeSeconds: false,
                              excludeTime: true,
                            })}
                          </Typography>
                          {(() => {
                            const startTime = formatTimeFromString(quotesData?.StartTime);
                            const endTime = formatTimeFromString(quotesData?.EndTime);
                            if (!startTime && !endTime) return null;
                            return (
                              <Typography
                                sx={{
                                  color: headingInk,
                                  fontSize: { xs: "13px", sm: "14px" },
                                  fontWeight: 500,
                                  wordBreak: "break-word",
                                }}
                              >
                                {startTime && <>Start Time: {startTime}</>}
                                {startTime && endTime && " · "}
                                {endTime && <>End Time: {endTime}</>}
                              </Typography>
                            );
                          })()}
                        </Box>
                        {!isConfirmed && !isComplete && (
                          <Box
                            component="span"
                            onClick={handleOpenChangeDateDialog}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 36,
                              height: 36,
                              borderRadius: "8px",
                              backgroundColor: ML_EDIT_TILE_BG,
                              border: `1px solid ${ML_EDIT_TILE_BORDER}`,
                              lineHeight: 0,
                              cursor: "pointer",
                              flexShrink: 0,
                              transition: "opacity 0.15s ease",
                              "&:hover": { opacity: 0.92 },
                            }}
                          >
                            <EditIcon
                              color={ML_EDIT_ICON}
                              style={{
                                marginRight: 0,
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                            />
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  {/* Assigned Workers */}
                  <Grid
                    size={{
                      xs: 12,
                      sm: 6,
                      md: 6
                    }}>
                    <Box
                      className="info-card"
                      sx={confirmLayout.infoCard}
                    >
                      <Typography sx={confirmLayout.infoLabel}>
                        Assigned Workers
                      </Typography>
                      {(() => {
                        const workers = [];
                        const workerSet = new Set();
                        if (Array.isArray(quotesData?.AssignPerson) && quotesData?.AssignPerson.length > 0) {
                          quotesData.AssignPerson.forEach((person) => {
                            let workerName = person?.FullName || (person?.FirstName && person?.LastName ? `${person.FirstName} ${person.LastName}` : null) || person?.OwnerName;
                            if (workerName && !workerSet.has(workerName)) {
                              workers.push(workerName);
                              workerSet.add(workerName);
                            }
                          });
                        }
                        if (Array.isArray(quotesData?.WorkerData) && quotesData?.WorkerData.length > 0) {
                          quotesData.WorkerData.forEach((worker) => {
                            const workerName = worker?.FirstName && worker?.LastName ? `${worker.FirstName} ${worker.LastName}` : worker?.FullName;
                            if (workerName && !workerSet.has(workerName)) {
                              workers.push(workerName);
                              workerSet.add(workerName);
                            }
                          });
                        }
                        if (workers.length === 0) {
                          if (quotesData?.AssignPerson?.FullName) workers.push(quotesData.AssignPerson.FullName);
                          else if (quotesData?.AssignPerson?.FirstName && quotesData?.AssignPerson?.LastName)
                            workers.push(`${quotesData.AssignPerson.FirstName} ${quotesData.AssignPerson.LastName}`);
                          else if (quotesData?.AssignPerson?.OwnerName) workers.push(quotesData.AssignPerson.OwnerName);
                          else if (quotesData?.WorkerName) workers.push(quotesData.WorkerName);
                          else if (quotesData?.AssignWorker) workers.push(quotesData.AssignWorker);
                        }
                        return workers.length > 0 ? (
                          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25 }}>
                            {workers.map((worker, index) => (
                              <Box
                                key={index}
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "8px 14px",
                                  backgroundColor: paperBg,
                                  borderRadius: "8px",
                                  border: "1px solid #E5E9F2",
                                }}
                              >
                                <Typography sx={{ color: headingInk, fontWeight: 500, fontSize: "12px" }}>
                                  {worker}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        ) : (
                          <Typography sx={{ color: "#6B7280", fontSize: "14px", fontStyle: "italic" }}>
                            Not Assigned
                          </Typography>
                        );
                      })()}
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={{ xs: 2.5, sm: 3 }}>
                  <Grid size={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 2, sm: 2.5 },
                      }}
                    >
                      {/* Materials & Labor - Always show */}
                      <Box>
                        <Box
                          sx={{ marginBottom: { xs: 1.5, sm: 2 } }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              fontSize: "18px",
                              color: headingInk,
                              margin: 0,
                              paddingBottom: { xs: 1.25, sm: 1.5 },
                            }}
                          >
                            Materials & Labor
                          </Typography>
                          <Box
                            className="bg-orange-color"
                            sx={{ height: "2px", width: "100%", borderRadius: "2px" }}
                            aria-hidden
                          />
                        </Box>
                        <Box sx={confirmLayout.materialsPanel}>
                          {(() => {
                            const items =
                              quotesData?.ContractItemData ||
                              quotesData?.ContractData?.[0]?.Items ||
                              quotesData?.Items ||
                              [];

                            // Calculate totals
                            let materialSubTotal =
                              quotesData?.MaterialSubTotal || 0;
                            let laborSubTotal = quotesData?.LaborSubTotal || 0;
                            let totalTaxes =
                              quotesData?.TotalCalculatedTaxes || 0;
                            let grandTotal = quotesData?.Total || 0;

                            // If totals not available, calculate from items
                            if (
                              materialSubTotal === 0 &&
                              laborSubTotal === 0 &&
                              items.length > 0
                            ) {
                              items.forEach((item) => {
                                const total = parseFloat(item?.Total || 0);
                                if (item?.Type === "Materials") {
                                  materialSubTotal += total;
                                } else if (item?.Type === "Labor") {
                                  laborSubTotal += total;
                                } else {
                                  materialSubTotal += total;
                                }
                              });
                            }

                            if (grandTotal === 0) {
                              grandTotal =
                                materialSubTotal + laborSubTotal + totalTaxes;
                            }

                            // Get tax information
                            const contractData =
                              quotesData?.ContractData?.[0] ||
                              quotesData?.ContractData ||
                              {};
                            const taxPercent = parseFloat(
                              contractData?.Tax || 0
                            );
                            const calculatedTaxes =
                              quotesData?.CalculatedTaxes ||
                              contractData?.CalculatedTaxes ||
                              [];

                            // Calculate tax amount if percentage is provided but totalTaxes is 0
                            if (taxPercent > 0 && totalTaxes === 0) {
                              const subtotal = materialSubTotal + laborSubTotal;
                              totalTaxes = (subtotal * taxPercent) / 100;
                            }

                            // Calculate total taxes from calculated taxes if not provided
                            if (
                              totalTaxes === 0 &&
                              calculatedTaxes.length > 0
                            ) {
                              totalTaxes = calculatedTaxes.reduce(
                                (sum, tax) =>
                                  sum + parseFloat(tax?.amount || 0),
                                0
                              );
                            }

                            // Sum all calculated taxes (always use calculated taxes array if available)
                            const allCalculatedTaxes =
                              calculatedTaxes.length > 0
                                ? calculatedTaxes.reduce(
                                    (sum, tax) =>
                                      sum + parseFloat(tax?.amount || 0),
                                    0
                                  )
                                : totalTaxes;

                            // Calculate grand total: material + labor + all taxes
                            // Always recalculate to ensure accuracy
                            grandTotal =
                              materialSubTotal +
                              laborSubTotal +
                              allCalculatedTaxes;

                            // Only use provided total if it matches our calculation (within 0.01 tolerance)
                            if (
                              quotesData?.Total &&
                              Math.abs(
                                parseFloat(quotesData.Total) - grandTotal
                              ) <= 0.01
                            ) {
                              grandTotal = parseFloat(quotesData.Total);
                            }

                            return items.length > 0 ? (
                              <>
                                <Box>
                                  {items.map((item, index) => (
                                    <Box
                                      key={
                                        item._id || item.ContractItemId || index
                                      }
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 0",
                                        borderBottom:
                                          index < items.length - 1
                                            ? "1px solid #E5E9F2"
                                            : "none",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: "13px",
                                          fontWeight: 500,
                                          color: headingInk,
                                          flex: 1,
                                        }}
                                      >
                                        {item?.Name ||
                                          "Materials and Labor not Available"}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          textAlign: "right",
                                          fontSize: "13px",
                                          color: headingInk,
                                          fontWeight: 500,
                                          minWidth: "120px",
                                        }}
                                      >
                                        {item.Unit
                                          ? `${item?.Unit} Units`
                                          : item.Hourly
                                          ? `${item?.Hourly} Hours`
                                          : item.Square
                                          ? `${item?.Square} SqFeet`
                                          : item.Fixed
                                          ? `${item?.Fixed} Fixed`
                                          : "Unit not available"}
                                      </Typography>
                                    </Box>
                                  ))}
                                </Box>

                                {/* Totals Section */}
                                <Box
                                  sx={{
                                    mt: 2,
                                    pt: 2,
                                    borderTop: "2px solid #E5E9F2",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      mb: "6px",
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: muted,
                                        fontSize: "12px",
                                        fontWeight: 400,
                                      }}
                                    >
                                      Material Subtotal:
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: headingInk,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      ${Number(materialSubTotal).toFixed(2)}
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      mb: "6px",
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: muted,
                                        fontSize: "12px",
                                        fontWeight: 400,
                                      }}
                                    >
                                      Labor Subtotal:
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: headingInk,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                      }}
                                    >
                                      ${Number(laborSubTotal).toFixed(2)}
                                    </Typography>
                                  </Box>
                                  {/* Show regular tax with percentage if exists */}
                                  {taxPercent > 0 && (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: "6px",
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: muted,
                                          fontSize: "12px",
                                          fontWeight: 400,
                                        }}
                                      >
                                        Tax ({taxPercent}%):
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: headingInk,
                                          fontSize: "12px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        ${Number(totalTaxes).toFixed(2)}
                                      </Typography>
                                    </Box>
                                  )}
                                  {/* Show calculated taxes with percentages */}
                                  {calculatedTaxes.length > 0 &&
                                    calculatedTaxes.map((tax, taxIndex) => {
                                      const isPercentageTax =
                                        tax?.feeType === "Percentage" ||
                                        (tax?.percentage &&
                                          tax?.percentage > 0);
                                      const taxAmount = parseFloat(
                                        tax?.amount || 0
                                      );
                                      const taxPercentage =
                                        tax?.percentage || 0;
                                      const taxName = tax?.name || "Tax";
                                      const taxType = tax?.type
                                        ? ` - ${tax.type}`
                                        : "";

                                      if (taxAmount <= 0) return null;

                                      return (
                                        <Box
                                          key={taxIndex}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: "6px",
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              color: muted,
                                              fontSize: "12px",
                                              fontWeight: 400,
                                            }}
                                          >
                                            {isPercentageTax &&
                                            taxPercentage > 0
                                              ? `${taxName} (${taxPercentage}%)${taxType}:`
                                              : `${taxName}${taxType}:`}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              color: headingInk,
                                              fontSize: "12px",
                                              fontWeight: 500,
                                            }}
                                          >
                                            ${Number(taxAmount).toFixed(2)}
                                          </Typography>
                                        </Box>
                                      );
                                    })}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      mt: 1.5,
                                      pt: 1.5,
                                      borderTop: "1px solid #E5E9F2",
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        color: headingInk,
                                        fontSize: "14px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Total:
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        color: headingInk,
                                        fontSize: "14px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      ${Number(grandTotal).toFixed(2)}
                                    </Typography>
                                  </Box>
                                </Box>
                              </>
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#999",
                                  fontSize: "12px",
                                  textAlign: "center",
                                  padding: "16px",
                                  fontStyle: "italic",
                                }}
                              >
                                No materials and labor items available
                              </Typography>
                            );
                          })()}
                        </Box>
                      </Box>
                    </Box>
                  </Grid>

                  {/* Date Change Requests - Full width below */}
                  <Grid size={12}>
                    <Box sx={confirmLayout.dateChangeWrap}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                      <Box sx={confirmLayout.dateChangeHeader}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            fontSize: "15px",
                            margin: 0,
                          }}
                        >
                          Date Change Requests
                        </Typography>
                      </Box>
                      <Box
                        className="bg-orange-color"
                        sx={{ height: "2px", width: "100%", flexShrink: 0 }}
                        aria-hidden
                      />
                      </Box>
                      <Box
                        sx={{
                          padding:
                            dateChangeRequests && dateChangeRequests.length > 0
                              ? { xs: "16px", sm: "20px" }
                              : { xs: "14px 16px", sm: "16px 20px" },
                          maxHeight: dateChangeRequests && dateChangeRequests.length > 0 ? "400px" : "none",
                          overflowY: dateChangeRequests && dateChangeRequests.length > 0 ? "auto" : "visible",
                        }}
                      >
                        {dateChangeRequests && dateChangeRequests.length > 0 ? (
                          dateChangeRequests.map((request, index) => (
                            <Box
                              key={request.RequestId || index}
                              sx={{
                                padding: { xs: "14px", sm: "16px" },
                                marginBottom:
                                  index < dateChangeRequests.length - 1
                                    ? { xs: "12px", sm: "16px" }
                                    : 0,
                                border: "1px solid #E5E9F2",
                                backgroundColor: paperBg,
                                borderRadius: "8px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                  mb: "12px",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: headingInk,
                                    fontSize: "13px",
                                  }}
                                >
                                  {request.RequestedBy === "Customer"
                                    ? "Customer"
                                    : request.RequestedBy === "Worker"
                                    ? "Worker"
                                    : request.RequestedBy}
                                </Typography>
                                <Box
                                  sx={{
                                    backgroundColor:
                                      request.Status === "Pending"
                                        ? themeColors?.orange
                                        : request.Status === "Approved"
                                        ? "#28a745"
                                        : "#dc3545",
                                    color: "white",
                                    padding: "4px 10px",
                                    borderRadius: "12px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                  }}
                                >
                                  {request.Status}
                                </Box>
                              </Box>
                              <Box sx={{ mb: "6px" }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: muted,
                                    fontSize: "12px",
                                    display: "inline",
                                    fontWeight: 500,
                                  }}
                                >
                                  Current:{" "}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: headingInk,
                                    fontSize: "12px",
                                    display: "inline",
                                    fontWeight: 600,
                                  }}
                                >
                                  {formatDateWithUserTimezone(request.CurrentDate, {
                                    dateFormat: dateFormat,
                                    includeSeconds: false
                                  })}
                                </Typography>
                              </Box>
                              <Box sx={{ mb: "6px" }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: muted,
                                    fontSize: "12px",
                                    display: "inline",
                                    fontWeight: 500,
                                  }}
                                >
                                  Requested:{" "}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: headingInk,
                                    fontSize: "12px",
                                    display: "inline",
                                    fontWeight: 600,
                                  }}
                                >
                                  {formatDateWithUserTimezone(request.RequestedDate, {
                                    dateFormat: dateFormat,
                                    includeSeconds: false
                                  })}
                                </Typography>
                              </Box>
                              {request.Reason && (
                                <Box
                                  sx={{
                                    mb: "6px",
                                    mt: "8px",
                                    paddingTop: "8px",
                                    borderTop: "1px solid #d1d5db",
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: muted,
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      mb: "4px",
                                    }}
                                  >
                                    Reason:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: headingInk,
                                      fontSize: "12px",
                                      wordBreak: "break-word",
                                      overflowWrap: "break-word",
                                      lineHeight: 1.5,
                                      display: "block",
                                    }}
                                  >
                                    {request.Reason}
                                  </Typography>
                                </Box>
                              )}
                              {request.Status !== "Pending" &&
                                request.ReviewReason && (
                                  <Box
                                    sx={{
                                      mb: "6px",
                                      mt: "8px",
                                      paddingTop: "8px",
                                      borderTop: "1px solid #d1d5db",
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: muted,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        mb: "4px",
                                      }}
                                    >
                                      Admin Response:
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: headingInk,
                                        fontSize: "12px",
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word",
                                        lineHeight: 1.5,
                                        display: "block",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {request.ReviewReason}
                                    </Typography>
                                  </Box>
                                )}
                            </Box>
                          ))
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              color: muted,
                              fontSize: "13px",
                              fontStyle: "italic",
                              margin: 0,
                            }}
                          >
                            No date change requests available
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Fade>
      )}
      {/* CustomSwal for Confirm Appointment */}
      <CustomSwal
        isOpen={showConfirmSwal}
        onClose={() => setShowConfirmSwal(false)}
        onConfirm={handleConfirmAppointmentConfirm}
        title="Are you sure?"
        text="Do you want to confirm this appointment?"
        confirmButtonText="Yes, confirm it!"
        cancelButtonText="No, cancel"
        requireInput={false}
      />
      {/* CustomSwal for Complete Appointment */}
      <CustomSwal
        isOpen={showCompleteSwal}
        onClose={() => setShowCompleteSwal(false)}
        onConfirm={handleCompleteAppointmentConfirm}
        title="Are you sure?"
        text="Do you want to complete this appointment?"
        confirmButtonText="Yes, complete it!"
        cancelButtonText="No, cancel"
        requireInput={false}
      />
      {/* Change Date Dialog */}
      <Dialog
        open={showChangeDateDialog}
        onClose={handleCloseChangeDateDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            overflow: "hidden",
            maxWidth: "500px",
            width: "100%",
            border: "1px solid #E5E9F2",
            boxShadow: "0 4px 24px rgba(15, 43, 70, 0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: paperBg,
            color: headingInk,
            padding: 0,
            margin: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              padding: "1.25rem 1.5rem 1rem",
            }}
          >
            <Typography
              component="span"
              variant="h6"
              sx={{
                fontSize: "1.125rem",
                fontWeight: 600,
                color: headingInk,
                lineHeight: 1.3,
              }}
            >
              Change Appointment Date
            </Typography>
            <IconButton
              onClick={handleCloseChangeDateDialog}
              aria-label="Close"
              size="small"
              sx={{
                color: headingInk,
                flexShrink: 0,
                "&:hover": {
                  backgroundColor: "rgba(15, 43, 70, 0.08)",
                },
              }}
            >
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Box>
          <Box
            className="bg-orange-color"
            sx={{ height: "2px", width: "100%", flexShrink: 0 }}
            aria-hidden
          />
        </DialogTitle>
        <DialogContent sx={{ padding: "1.5rem", pt: "1.25rem !important" }}>
          <Typography
            variant="body2"
            sx={{
              mb: 2,
              color: "#6B7280",
              fontSize: "0.875rem",
              lineHeight: 1.5,
            }}
          >
            Select a new date for your appointment
          </Typography>
          <Box sx={{ mb: 2.5 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="New Appointment Date"
                value={newDate}
                onChange={(newValue) => {
                  setNewDate(newValue);
                  if (dateError && newValue) {
                    setDateError(false);
                  }
                }}
                format={dateFormat}
                minDate={dayjs()}
                shouldDisableDate={shouldDisableDate}
                sx={{ width: "100%" }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: "outlined",
                    error: dateError,
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: paperBg,
                        "& fieldset": {
                          borderColor: dateError ? "#dc3545" : "#E5E9F2",
                        },
                        "&:hover fieldset": {
                          borderColor: dateError ? "#dc3545" : "#d1d5db",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: dateError ? "#dc3545" : themeColors.blue,
                        },
                        "&.Mui-error fieldset": {
                          borderColor: "#dc3545",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: dateError ? "#dc3545" : "#6B7280",
                      },
                      "& .MuiInputLabel-root.Mui-focused": {
                        color: dateError ? "#dc3545" : themeColors.blue,
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "100%" }}>
            <InputText
              name="dateChangeReason"
              label="Reason for Date Change"
              placeholder="Please provide a reason for changing the appointment date"
              value={dateChangeReason}
              onChange={(e) => {
                setDateChangeReason(e.target.value);
                if (reasonError && e.target.value.trim()) {
                  setReasonError(false);
                }
              }}
              multiline
              rows={3}
              required
              fullWidth
              error={reasonError}
              sx={{ width: "100%" }}
            />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "1rem 1.5rem",
            borderTop: "1px solid #E5E9F2",
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            backgroundColor: "#FAFBFC",
          }}
        >
          <WhiteButton
            type="button"
            onClick={handleCloseChangeDateDialog}
            label="Cancel"
            style={{ minWidth: "100px" }}
          />
          <BlueButton
              onClick={async () => {
                // Reset errors
                setDateError(false);
                setReasonError(false);

                // Validate date
                if (!newDate || !quotesData) {
                  setDateError(true);
                  showToast.error("Please select a valid appointment date.");
                  return;
                }

                // Validate reason
                if (!dateChangeReason || !dateChangeReason.trim()) {
                  setReasonError(true);
                  showToast.error("Please provide a reason for changing the appointment date.");
                  return;
                }

                // Only proceed if date actually changed
                if (originalDate && newDate.isSame(originalDate, "day")) {
                  setDateError(true);
                  showToast.warning("Please select a different date than the current appointment date.");
                  return;
                }

                setDateChangeLoading(true);
                try {
                  const formattedDate = moment(newDate.toDate()).format(
                    "YYYY-MM-DD"
                  );
                  const visitId = getVisitId();

                  // Get ContractId from quotesData - check multiple possible locations
                  const contractId =
                    quotesData?.ContractId ||
                    quotesData?.ContractData?.[0]?.ContractId;

                  if (!contractId) {
                    showToast.error(
                      "Contract information is missing. Please refresh the page."
                    );
                    setDateChangeLoading(false);
                    return;
                  }

                  const response = await AxiosInstance.post(
                    `/v1/visit/date-change-request/${visitId}/${contractId}`,
                    {
                      RequestedDate: formattedDate,
                      Reason: dateChangeReason.trim(),
                    }
                  );

                  if (response?.data?.statusCode === 200) {
                    handleCloseChangeDateDialog();

                    // Show success toast
                    showToast.success(
                      "Date change request submitted successfully. Request is pending admin approval."
                    );

                    // Show email notification toasts for all emails (sent and failed)

                    if (
                      response?.data?.emailResults &&
                      Array.isArray(response.data.emailResults) &&
                      response.data.emailResults.length > 0
                    ) {
                      response.data.emailResults.forEach((emailInfo, index) => {
                        if (emailInfo && emailInfo.email && emailInfo.role) {
                          setTimeout(() => {
                            if (emailInfo.status === "sent") {
                              showToast.success(
                                `Email sent to ${emailInfo.role}: ${emailInfo.email}`,
                                {
                                  autoClose: 3000,
                                }
                              );
                            } else {
                              showToast.warning(
                                `Email failed to send to ${emailInfo.role}: ${emailInfo.email}`,
                                {
                                  autoClose: 3000,
                                }
                              );
                            }
                          }, 800 * (index + 1));
                        }
                      });
                    } else {
                    }

                    // Refresh date change requests immediately
                    try {
                      // Get ContractId from quotesData - check multiple possible locations
                      const contractIdForRefresh =
                        quotesData?.ContractId ||
                        quotesData?.ContractData?.[0]?.ContractId;
                      if (contractIdForRefresh) {
                        const requestsResponse = await AxiosInstance.get(
                          `/v1/visit/date-change-requests/${visitId}/${contractIdForRefresh}`
                        );

                        if (requestsResponse?.data?.statusCode === 200) {
                          setDateChangeRequests(
                            requestsResponse?.data?.data || []
                          );
                          const pendingRequests = (
                            requestsResponse?.data?.data || []
                          ).filter((req) => req.Status === "Pending");
                          if (pendingRequests.length > 0) {
                            setPendingRequest(pendingRequests[0]);
                          } else {
                            setPendingRequest(null);
                          }
                        }
                      }
                    } catch (error) {
                      console.error(
                        "Error refreshing date change requests:",
                        error
                      );
                    }
                  }
                } catch (error) {
                  console.error("Error creating date change request:", error);
                  const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Failed to submit the date change request. Please try again.";

                  // Show toast for all errors
                  if (error?.response?.status === 400) {
                    if (errorMessage.includes("already pending")) {
                      showToast.warning(
                        "A visit date change request is already pending for this visit."
                      );
                    } else if (errorMessage.includes("already exists on")) {
                      showToast.warning(errorMessage);
                    } else {
                      showToast.warning(errorMessage);
                    }
                  } else {
                    showToast.error(errorMessage);
                  }
                } finally {
                  setDateChangeLoading(false);
                }
              }}
              disabled={
                dateChangeLoading || !newDate || !dateChangeReason?.trim()
              }
              label={dateChangeLoading ? "Submitting..." : "Submit Request"}
              style={{ minWidth: "120px" }}
            />
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ConfirmAppointment;